import React from 'react';

export const Capabilities: React.FC = () => {
    const capabilities = [
        {
            icon: '🔍',
            text: 'Detect new DLMM LPs with unusual volume, APR, or volatility'
        },
        {
            icon: '🔔',
            text: 'Alert when pools meet your filter or AI strategy'
        },
        {
            icon: '⚡',
            text: 'Flash stake with optimized amounts based on liquidity'
        },
        {
            icon: '👥',
            text: 'Mirror successful traders strategies'
        },
        {
            icon: '💰',
            text: 'Reduce idle capital time and slippage risk'
        }
    ];

    return (
        <section className="py-24 bg-gradient-to-b from-purple-900/10 to-black">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <span className="inline-block px-6 py-3 bg-purple-500/10 border border-purple-500/30 rounded-full text-purple-300 text-lg font-semibold mb-4">
                        🧪 What NyxBot Can Do
                    </span>
                    <h2 className="text-5xl md:text-6xl font-bold text-white">
                        Powerful features for{' '}
                        <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
                            serious LP hunters
                        </span>
                    </h2>
                </div>

                <div className="space-y-4 max-w-4xl mx-auto">
                    {capabilities.map((capability, index) => (
                        <div
                            key={index}
                            className="flex items-center space-x-4 p-6 bg-black/40 border border-purple-500/20 rounded-xl hover:border-purple-500/40 hover:bg-purple-500/5 transition-all"
                        >
                            <span className="text-3xl flex-shrink-0">{capability.icon}</span>
                            <span className="text-lg text-gray-300">{capability.text}</span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};